/**
 * Retrieves the transformed video URL.
 * @param url - The original video URL. (Optional)
 * @returns The transformed video URL if successful, otherwise an empty string.
 * @category Utils
 */
export const getVideoTransformations = (url?: string): string => {
  const DEFAULT_NAMED_TRANSFORMATION = 'f_auto:video'
  if (!url) {
    log.debug('[@domains/core/utils/getVideoTransformations] Please provide a url.')
    return ''
  }

  if (url?.includes(DEFAULT_NAMED_TRANSFORMATION)) {
    log.debug('[@domains/core/utils/getVideoTransformations] No op. The transformations have already been applied.')
    return url
  }

  try {
    if (!url.includes('//assets.')) {
      log.debug('[@domains/core/utils/getVideoTransformations] Scene7 URL detected. Falling back to the legacy transformation logic.')
      return url
    }

    const urlObj = new URL(url)
    const urlPathValues = urlObj.pathname.split('/')

    if (urlPathValues.length !== 6) {
      log.debug('[@domains/core/utils/getVideoTransformations] The URL does not match the expected format.')
      return url
    }

    urlObj.pathname = `videos/t_productvideo/${DEFAULT_NAMED_TRANSFORMATION}/${urlPathValues[4]}/${urlPathValues[5]}`
    return decodeURIComponent(urlObj.toString())
  }
  catch (error: any) {
    log.error(`[@domains/core/utils/getVideoTransformations] Unable to transform the provided URL: ${url}.`, error)
    return ''
  }
}
